import { RowData, JsonSchema } from "../../../../types";
import {
  getExportSchemaTitles,
  getInputType,
  getSchemaSections,
} from "../schemaHelpers";
import { FIELDS_TO_EXCLUDE } from "./downloadFileUploadTemplate";
import { formatExcelValue } from "./formatExcelValue";

export const getMappedData = (
  jsonData: RowData[],
  schema: JsonSchema,
  metaData: {
    store_id: string;
    company_id: string;
    enterprise_id: string;
  },
): RowData[] => {
  const schemaTitles = getExportSchemaTitles(schema);
  const fieldsToImport = getFieldstoProcess(schema);

  return jsonData.map((row) => {
    const mappedRow: RowData = {};

    fieldsToImport.forEach((key) => {
      const property = schema.properties?.[key];
      const propertyType = property?.type
        ? getInputType(property.type)
        : "string";

      if (propertyType === "array" || propertyType === "object") {
        return;
      }

      mappedRow[key] = formatExcelValue(
        row[schemaTitles[key]] ?? null,
        propertyType,
        property?.format,
      );
    });

    return {
      ...mappedRow,
      ...metaData,
    };
  });
};

const getFieldstoProcess = (schema: JsonSchema): string[] => {
  const sections = getSchemaSections(schema);
  return sections
    .flatMap((section) => section.sectionValue)
    .filter((field) => !FIELDS_TO_EXCLUDE.has(field));
};
